import { PhosphorCheckCircle, PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";

interface Props {
  compliance: server.dto.EInvoiceSenderCompliance;
}

const error: server.dto.EInvoiceSenderCompliances[] = [
  "companyInformationMissing",
  "countryNotSupported"
];

const info: server.dto.EInvoiceSenderCompliances[] = [
  "readyForPeppolRegistration"
];

const success: server.dto.EInvoiceSenderCompliances[] = [
  "isRegistered",
];
export const EInvoiceSenderComplianceMessage = (props: Props) => {
  return <div className="flex gap">
    <div>
      {error.includes(props.compliance.value) && <PhosphorWarningCircle
        iconSize="large"
        iconWeight="fill"
        iconColor="error"
      />}

      {info.includes(props.compliance.value) && <PhosphorCheckCircle
        iconSize="large"
        iconWeight="fill"
        iconColor="yellow"
      />}

      {success.includes(props.compliance.value) && <PhosphorCheckCircle
        iconSize="large"
        iconWeight="fill"
        iconColor="green" />}

    </div>
    <div>
      <SmallDetails
        label={props.compliance.message}
        subLabel={props.compliance.messageSublabel}
      />
    </div>
  </div>
}